import React, { } from 'react'
import { bindActionCreators } from 'redux'
import { useDispatch, useSelector } from 'react-redux'
import { loadEmbedById } from 'state/actions/embeds'
import { goToPost } from 'state/actions/posts'
import ArticleSummary from 'components/ArticleSummary'
import styles from './LocalEmbed.css'
import { ReactFC } from 'types'
import { isSSR } from 'lib/isSSR'
import { isValidTag } from 'lib/isValidTag'
import { NoSsr } from '@material-ui/core'

const LocalEmbed: ReactFC<{ data: { url: string, description: string } }> = (props) => {
  const embeds = useEmbeds()

  const dispatch = useDispatch()
  const loadEmbeds = useLoadEmbeds()

  const load = (opt) => {
    const ssr = isSSR()
    if (ssr) {
      return
    }

    loadEmbeds(opt)
  }

  const getArticleOrError = () => {
    const { data: { url } } = props
    if (isValidTag(url)) {
      return { tag: url }
    }
    const container = embeds[url]

    if (!container) {
      load({ _id: url })
      return {}
    }

    if (container.error) {
      load({ _id: url })
    }

    return {
      article: container.value,
      error: container.error
    }
  }

  const goToArticle = () => {
    let { article } = getArticleOrError()
    if (article) {
      dispatch(
        goToPost({
          _id: article._id,
          group: article.group,
          username: article.author.username,
          name: article.name,
          meta: {
            push: true
          }
        })
      )
    }
  }

  const { data: { description } } = props
  const { article, error, tag } = getArticleOrError()
  return (
    <div className={styles.local_embed}>
      {tag && <HtmlTag tag={tag} />}
      {article && !tag ? (
        <ArticleSummary article={article} onClick={goToArticle} />
      ) : null}
      {error ? <span>something went wrong</span> : null}
      {description && description.length ? (
        <span className={styles.description}>{description}</span>
      ) : null}
    </div>
  )
}

const HtmlTag = ({ tag }) => {
  return (
    <NoSsr>
      <div dangerouslySetInnerHTML={{ __html: tag }}>
      </div>      
    </NoSsr>
  )
}

const selectEmbeds = ({ embeds }) => {
  return embeds || {}
}

const useEmbeds = () => {
  return useSelector(selectEmbeds)
}


const useLoadEmbeds = () => {
  const dispatch = useDispatch()
  return bindActionCreators(loadEmbedById, dispatch)
}

export default LocalEmbed
